  <template>
  <div>
    <div class="container-search">
      <el-form
        inline
        size="mini"
        label-width="70px"
        class="table-search-part more-search-part inline-wrapper"
        @submit.native.prevent="handleQuery()"
      >
        <div class="search-left order-search-left">
          <el-form-item label="Order Time">
            <el-date-picker
              v-model="orderTime"
              clearable
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              @change="orderDate"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Order ID">
            <el-input
              type="number"
              @mousewheel.native.prevent
              v-model="ordersId"
              placeholder="Order ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="User ID">
            <el-input @mousewheel.native.prevent v-model="userId" placeholder="User ID"></el-input>
          </el-form-item>
          <el-form-item label="Status">
            <el-select v-model="statusId" placeholder="Status" :popper-append-to-body="false">
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Channel">
            <el-select
              v-model="queryData.merchantId"
              placeholder="Merchant"
              clearable
              filterable
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in merchatList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bet Type">
            <el-select v-model="queryData.seriesType" :popper-append-to-body="false">
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in betTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Match ID">
            <el-input
              type="number"
              @mousewheel.native.prevent
              v-model="matchsId"
              placeholder="Match ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="IP">
            <el-input clearable v-model="queryData.ip" placeholder="IP"></el-input>
          </el-form-item>
          <el-form-item label="Settlement Time" v-if="allSearchVisible">
            <el-date-picker
              v-model="settleTime"
              :clearable="false"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              @change="settleDate"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Sport" v-if="allSearchVisible">
            <el-select
              v-model="sportId"
              filterable
              placeholder="Sport"
              :popper-append-to-body="false"
              @change="getSport(sportId)"
            >
              <el-option value label="All"></el-option>
              <el-option
                v-for="item in sportList"
                :key="Number(item.code)"
                :label="item.value"
                :value="Number(item.code)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Market" v-if="allSearchVisible">
            <el-select
              v-model="queryData.marketTypes"
              multiple
              collapse-tags
              placeholder="Market"
              :popper-append-to-body="false"
              @click.native="getMarketList()"
            >
              <el-option
                v-for="(item,index) in marketList"
                :key="index"
                :label="item.marketName"
                :value="item.marketType"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Period" v-if="allSearchVisible">
            <el-select
              v-model="queryData.period"
              multiple
              collapse-tags
              placeholder="Period"
              :popper-append-to-body="false"
              @click.native="getPeriodList()"
            >
              <el-option
                v-for="(item,index) in periodList"
                :key="index"
                :label="item.value"
                :value="item.code*1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Match Type" v-if="allSearchVisible">
            <el-select
              v-model="queryData.isInplay"
              placeholder="Match Type"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in matchTypeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="search-right inline-right order-search-right">
          <el-button class="search-btn" @click="handleQuery()">Search</el-button>
          <el-button class="clear-btn" @click="handleClearQuery()">Clear</el-button>
          <el-button class="more-btn" @click="getAllSearch()">
            More
            <i :class="allSearchVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="middle-btn inline-wrapper">
      <div class="info-wrapper">
        <el-select
          class="select-btn"
          v-model="riskflagData.riskFlag"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in riskflagList"
            :key="item.code"
            :label="item.value"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button class="lebel-risk-export-btn info-btn" @click="modifyRiskflag(0)">Info</el-button>
        <el-button class="lebel-risk-export-btn" @click="modifyRiskflag(1)">Remove Info</el-button>
      </div>
      <div class="inline-right info-export-right">
        <el-button class="lebel-risk-export-btn" id="download" @click="handleExport()">
          <i class="icon iconfont iconProperty1xiazai"></i>
          Export
        </el-button>
      </div>
    </div>
    <div class="order-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        :stripe="true"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column type="selection" align="center" width="36"></el-table-column>
        <el-table-column label="Order ID" prop="orderId" min-width="155px">
          <template v-slot="{row}">
            <div>{{row.userId}}</div>
            <div>{{row.merchantName}}</div>
            <div>{{row.orderId}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Order Time/Status" min-width="156px">
          <template v-slot="{row}">
            <div v-if="row.orderTime">{{ formatUtc(row.orderTime) }}</div>
            <div v-for="(item, index) in statusList" :key="index">
              <span
                v-if="row.status == item.id"
                :class="{'text-blue':row.status == 4,'text-green':row.status == 5}"
              >{{ item.label }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Bet Type" min-width="70">
          <template v-slot="{row}">
            <div v-if="row.allUp == 1">Single</div>
            <div v-if="row.allUp != 1">
              <p>Parlay</p>
              <p>{{row.betType}}</p>
            </div>
            <div :class="['red',{'red-flag': row.riskFlagName}]">{{row.riskFlagName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Match" min-width="302px">
          <template v-slot="{ row }">
            <div
              v-for="(item, index) in row.betDetail"
              :key="index"
              :class="[{'table-td-item': row.allUp != 1}, 'match']"
            >
              <p>
                {{item.sportName}}
                <span v-if="item.matchId" class="matchId">{{item.matchId}}</span>
                {{formatUtc(item.beginTime)}}
              </p>
              <p class="home-away">
                {{item.home}}
                <span v-if="item.home && item.away">VS</span>
                {{item.away}}
              </p>
              <p v-if="[1020,1021,1022,1023].includes(Number(item.sportId))">{{item.matchName}}</p>
              <p v-else>{{item.leagueName}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Details" min-width="220px">
          <template v-slot="{row}">
            <div
              v-for="(item,index) in row.betDetail"
              :key="index"
              :class="[{'table-td-item': row.allUp != 1}, 'detail']"
            >
              <div>
                <div>
                  {{ item.optionName }}
                  <span v-if="row.allUp != 1">
                    / @
                    <el-button
                      type="text"
                      class="text-blue"
                      @click="showDialog(false,2,row.orderTime,item)"
                    >{{item.odds}}</el-button>
                  </span>
                </div>
                <p>
                  <span v-if="item.isInplay" class="text-red">Live</span>
                  <span v-if="!item.isInplay && item.matchType != 1 && item.matchType != 5" class="text-red">PreMatch</span>
                  <span v-if="item.matchType != 1 || item.matchType != 5">{{ item.periodName }}</span>
                  <span>
                    {{ item.marketName }}
                    <span v-if="item.extraInfo">({{item.extraInfo}})</span>
                  </span>
                  <br />
                  <span>{{ item.betScore }}</span>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Result" min-width="120px">
          <template v-slot="{row}">
            <div
              v-for="(item,index) in row.betDetail"
              :key="index"
              :class="[{'table-td-item': row.allUp != 1}, 'result']"
            >
              <p class="result-text" v-if="item.settleResult == 7">
                <span>.</span>Cancel
              </p>
              <p class="text-blue result-text" v-if="item.settleResult == 2">
                <span>.</span>Push
              </p>
              <p class="text-green result-text" v-if="item.settleResult == 3">
                <span>.</span>Loss
              </p>
              <p class="text-red result-text" v-if="item.settleResult == 4">
                <span>.</span>Win
              </p>
              <p class="text-red result-text" v-if="item.settleResult == 5">
                <span>.</span>WinReturn
              </p>
              <p class="text-green result-text" v-if="item.settleResult == 6">
                <span>.</span>LossReturn
              </p>
              <p v-if="item.matchResult">Result {{item.matchResult}}</p>
              <p>{{item.cancelReasonValue}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Odds" min-width="65px" align="right">
          <template v-slot="{row}">
            <div v-if="row.allUp == 1">
              @
              <el-button
                type="text"
                class="text-blue"
                @click="showDialog(row,2,row.orderTime,row.oddsLevel)"
              >{{row.betDetail[0].odds}}</el-button>
            </div>
            <div
              v-if="row.allUp != 1"
              class="odds"
            >@ {{odds(row.maxWinAmount,row.stakeAmount,row.betNum)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Company Win/Loss" prop="profit" min-width="130px" align="right">
          <template v-slot="{row}">
            <div
              :class="{'text-red': Math.sign(row.profit) == 1,'text-green':Math.sign(row.profit) == -1}"
            >{{formatMoney(row.profit*row.exchangeRate)}}</div>
            <div
              v-if="row.currency != 1 && row.profit != 0"
              :class="{'text-red': Math.sign(row.profit) == 1,'text-green':Math.sign(row.profit) == -1}"
            >
              <span>{{row.currencyCode}}&nbsp;</span>
              <span>{{row.profit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="IP" min-width="185px">
          <template v-slot="{ row }">
            <div>{{row.terminal}}</div>
            <div class="ip">{{row.ip}}</div>
            <div class="region">{{row.region}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Stake" prop="stakeAmount" min-width="95px" align="right">
          <template v-slot="{row}">
            <div>{{formatMoney(row.stakeAmount*row.exchangeRate)}}</div>
            <div v-if="row.currency != 1 && row.stakeAmount != 0" style="color: #999;">
              <span>{{row.currencyCode}}&nbsp;</span>
              <span>{{row.stakeAmount}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Settle Stake" prop="settleStake" min-width="95px" align="right">
          <template v-slot="{row}">
            <div v-if="row.settleStake != null">
              <div>{{formatMoney(row.settleStake*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.settleStake != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.settleStake}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Settle Return" prop="settleReturn" min-width="97px" align="right">
          <template v-slot="{row}">
            <div v-if="row.settleReturn != null">
              <div>{{formatMoney(row.settleReturn*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.settleReturn != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.settleReturn}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Cashout Stake" min-width="110px" align="center">
          <template v-slot="{ row }">
            <el-button
              style="width: 100px;padding: 0 10px;"
              type="text"
              class="text-blue"
              @click="showDialog(row,1)"
            >
              <div style="margin-bottom: 4px;">{{formatMoney(row.cashoutStake*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.cashoutStake != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.cashoutStake}}</span>
              </div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="Cashout Return"
          prop="cashoutPayout"
          min-width="112px"
          align="right"
        >
          <template v-slot="{row}">
            <div>{{formatMoney(row.cashoutPayout*row.exchangeRate)}}</div>
            <div v-if="row.currency != 1 && row.cashoutPayout != 0" style="color: #999;">
              <span>{{row.currencyCode}}&nbsp;</span>
              <span>{{row.cashoutPayout}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Settlement Time" min-width="141px" align="right">
          <template v-slot="{row}">
            <div v-if="row.settleTime">{{ formatUtc(row.settleTime) }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <dia ref="dialogDom">
      <!-- cashout1 -->
      <div v-if="num == 1">
        <div class="cashout-header">
          <p>Cashout Detail</p>
          <span class="cashout-header-count">Cashout Count: {{cashoutCount}}</span>
        </div>
        <el-table border :data="cashoutList" :key="1" v-loading="dialogLoading">
          <el-table-column prop="orderId" label="Cashout Order ID" width="150" align="right"></el-table-column>
          <el-table-column label="Cashout Time" width="160" align="right">
            <template v-slot="{row}">
              <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="cashOutStake" label="Cashout Stake" width="120" align="right">
            <template v-slot="{row}">
              <div>{{formatMoney(row.cashOutStake*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.cashOutStake != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.cashOutStake}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="cashOutPayoutStake"
            label="Cashout Payout"
            width="120"
            align="right"
          >
            <template v-slot="{row}">
              <div>{{formatMoney(row.cashOutPayoutStake*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.cashOutPayoutStake != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.cashOutPayoutStake}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="cashoutProfit" label="Cashout Profit" width="120" align="right">
            <template v-slot="{row}">
              <div>{{formatMoney(row.cashoutProfit*row.exchangeRate)}}</div>
              <div v-if="row.currency != 1 && row.cashoutProfit != 0" style="color: #999;">
                <span>{{row.currencyCode}}&nbsp;</span>
                <span>{{row.cashoutProfit}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Cashout Order Status" width="150" align="right">
            <template v-slot="{ row }">
              <span v-for="(item, index) in statusList" :key="index">
                <span v-if="row.orderStatus == item.id">{{ item.label }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 赔率2 -->
      <div v-if="num == 2" class="dialog-odd-wrapper">
        <div class="dialog-more">
          <el-button class="dialog-more-btn" @click="moreOddsList()">
            <i class="el-icon-plus"></i> More
          </el-button>
        </div>
        <el-table :data="oddsList" :key="2" :row-style="isRed" v-loading="dialogLoading" border>
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Time" width="140px">
            <template v-slot="{row}">
              <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="odds" label="Odds" width="130px"></el-table-column>
          <el-table-column prop="difference" label="Difference" width="186px"></el-table-column>
        </el-table>
      </div>
    </dia>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { formatAmount } from "@/utils";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import { getMerchat } from "@/api/member";
import {
  getOrderList,
  getTcsSportList,
  getMarketList,
  getPeriodList,
  getExport,
  getCashoutList,
  getOddsList
} from "@/api/memberDetail";
import { getRiskflagList, updateRiskflag } from "@/api/systemOrder";
export default {
  name: "OrderList",
  components: {
    dia,
    Empty
  },
  data() {
    return {
      formatAmount,
      list: [],
      merchatList: [],
      loading: false,
      dialogLoading: false,
      total: 0,
      queryData: {
        merchantId: "",
        merchantIds: [],
        ip: "",
        userIds: [],
        seriesType: "",
        orderStartTime: "",
        orderEndTime: "",
        settleStartTime: "",
        settleEndTime: "",
        orderIds: [],
        orderStatus: [],
        sportIds: [],
        matchIds: [],
        marketTypes: [],
        result: [],
        isInplay: "",
        period: [],
        timeZoneOffset: "",
        current: 1,
        size: 50
      },
      cashoutQueryData: {
        orderId: 0,
        orderStatus: 0
      },
      riskflagData: {
        orderIds: [],
        riskFlag: ""
      },
      oddsQueryData: {
        beginTime: "",
        endTime: "",
        odds: 0,
        matchId: 0,
        marketId: 0,
        period: 0,
        optionType: 0,
        oddsLevel: ""
      },
      marketQueryData: {
        sportIds: []
      },
      ordersId: "",
      userId: "",
      sportId: "",
      matchsId: "",
      statusId: "",
      tableHeight: window.innerHeight,
      orderTime: [],
      settleTime: [],
      matchTypeList: [
        {
          id: true,
          label: "Live"
        },
        {
          id: false,
          label: "Pre-Match"
        }
      ],
      resultList: [
        {
          id: 2,
          label: "Loss"
        },
        {
          id: 1,
          label: "Win"
        }
      ],
      statusList: [
        {
          id: 0,
          label: "Created"
        },
        {
          id: 1,
          label: "Confirming"
        },
        {
          id: 2,
          label: "Rejected"
        },
        {
          id: 3,
          label: "Canceled"
        },
        {
          id: 4,
          label: "Confirmed"
        },
        {
          id: 5,
          label: "Settled"
        }
      ],
      betTypeList: [
        {
          id: 0,
          label: "Single"
        },
        {
          id: 1,
          label: "Parlay"
        }
      ],
      num: "",
      sportList: [],
      marketList: [],
      oddsList: [],
      cashoutList: [],
      periodList: [],
      riskflagList: [],
      multipleSelection: [],
      cashoutCount: 0,
      allSearchVisible: false,
      curDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: time => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.curDate - one;
            const maxTime = this.curDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      }
    };
  },
  methods: {
    orderDate(val) {
      if (val != null) {
        const [startTime, endTime] = val;
        this.queryData.orderStartTime = startTime;
        this.queryData.orderEndTime = endTime;
      } else {
        this.queryData.orderStartTime = "";
        this.queryData.orderEndTime = "";
      }
    },
    formatMoney(val) {
      if (!val) {
        return 0;
      }
      return Math.floor(val * 100) / 100;
    },
    settleDate(val) {
      if (val != null) {
        const [startTime, endTime] = val;
        this.queryData.settleStartTime = startTime;
        this.queryData.settleEndTime = endTime;
      } else {
        this.queryData.settleStartTime = "";
        this.queryData.settleEndTime = "";
      }
    },
    async getList() {
      this.queryData.orderStatus = [];
      if (this.statusId !== "") {
        this.queryData.orderStatus.push(this.statusId);
      }
      this.queryData.merchantIds = this.queryData.merchantId
        ? [this.queryData.merchantId]
        : [];
      this.queryData.userIds = this.userId
        ? this.userId.replace(/\s+/g, "").split(",")
        : [];
      this.queryData.matchIds = this.matchsId
        ? this.matchsId.replace(/\s+/g, "").split(",")
        : [];
      this.queryData.orderIds = this.ordersId
        ? this.ordersId.replace(/\s+/g, "").split(",")
        : [];
      this.queryData = this.deleteEmptyQuery(this.queryData);
      this.loading = true;
      try {
        const res = await getOrderList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getSportList() {
      try {
        const res = await getTcsSportList({ matchType: '' });
        const data = res.data || [];
        this.sportList = data;
        // this.sportList = Object.values(data).filter(
        //   e =>
        //     e.sportId == 1 ||
        //     e.sportId == 3 ||
        //     e.sportId == 5 ||
        //     e.sportId == 13
        // );
      } catch (error) {
        this.sportList = [];
      }
    },
    async getRiskflagList() {
      try {
        const res = await getRiskflagList();
        const data = res.data || {};
        this.riskflagList = data || [];
        this.riskflagData.riskFlag = this.riskflagList[0].code;
      } catch (error) {
        this.riskflagList = [];
      }
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.queryData.orderIds = Object.values(this.multipleSelection).map(
        el => el.orderId
      );
    },
    modifyRiskflag(num) {
      if (this.multipleSelection.length > 0) {
        this.riskflagData.orderIds = Object.values(this.multipleSelection).map(
          el => el.orderId
        );
        if (num == 1) {
          this.riskflagData.riskFlag = "";
        }
        this.updateRiskflag();
      } else {
        this.$message({
          message: "Must checked one",
          type: "warning"
        });
      }
    },
    async updateRiskflag() {
      try {
        const res = await updateRiskflag(this.riskflagData);
        const data = res.data || {};
        if (res.success) {
          this.$message({
            message: "success",
            type: "success"
          });
          this.getList();
          this.riskflagData.riskFlag = this.riskflagList[0].code;
        }
      } catch (error) {}
    },
    async getMarketList() {
      if (!this.queryData.sportIds) {
        this.$message({
          message: "Must checked sport first",
          type: "warning"
        });
      } else {
        try {
          const res = await getMarketList(this.marketQueryData.sportIds);
          const data = res.data || {};
          this.marketList = data || [];
        } catch (error) {
          this.marketList = [];
        }
      }
    },
    async getPeriodList() {
      if (!this.queryData.sportIds) {
        this.$message({
          message: "Must checked sport first",
          type: "warning"
        });
      } else {
        try {
          const res = await getPeriodList(this.marketQueryData.sportIds);
          const data = res.data || {};
          this.periodList = data || [];
        } catch (error) {
          this.periodList = [];
        }
      }
    },
    getSport(e) {
      this.queryData.sportIds = [];
      this.marketQueryData.sportIds = [];
      if (e !== "") {
        this.queryData.sportIds.push(e);
        this.marketQueryData.sportIds.push(e);
      }
    },
    deleteEmptyQuery(data) {
      return Object.entries(data)
        .filter(
          ([key, value]) => (value && value.length) || !Array.isArray(value)
        )
        .reduce((prev, [key, value]) => {
          prev[key] = value;
          return prev;
        }, {});
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    handleClick() {
      this.handleClear();
      this.getList();
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      //this.getList();
    },
    // 清空
    handleClear() {
      this.queryData = {
        ...this.queryData,
        merchantId: "",
        merchantIds: [],
        ip: "",
        userIds: [],
        orderStartTime: "",
        orderEndTime: "",
        settleStartTime: "",
        settleEndTime: "",
        orderIds: [],
        orderStatus: [],
        sportIds: [],
        period: [],
        matchIds: [],
        marketTypes: [],
        result: [],
        isInplay: "",
        timeZoneOffset: "",
        current: 1,
        size: 50
      };
      this.orderTime = [];
      this.settleTime = [];
      this.statusId = "";
      this.ordersId = "";
      this.sportId = "";
      this.matchsId = "";
      this.userId = "";
      this.marketList = [];
    },
    isRed({ row }) {
      if (row.difference == 0) {
        return {
          backgroundColor: "#f8e6e5",
          color: "#e1554f"
        };
      }
    },
    showDialog(row, num, orderTime, item) {
      this.num = num;

      // cashout
      if (this.num == 1) {
        this.cashoutCount = row.cashoutCount;
        this.cashoutQueryData.orderId = row.orderId;
        this.cashoutQueryData.orderStatus = row.status;
        this.getCashoutList();
        this.$refs["dialogDom"].isShowDia(this.title, true, "860px");
      } else if (this.num == 2) {
        // odds
        this.oddsQueryData.odds = row ? row.betDetail[0].odds : item.odds;
        this.oddsQueryData.oddsLevel = item ? item : 1;
        this.oddsQueryData.matchId = row
          ? row.betDetail[0].matchId
          : item.matchId;
        this.oddsQueryData.marketId = row
          ? row.betDetail[0].marketId
          : item.marketId;
        this.oddsQueryData.period = row ? row.betDetail[0].period : item.period;
        this.oddsQueryData.optionType = row
          ? row.betDetail[0].optionType
          : item.optionType;
        let endTime = this.$moment(Number(orderTime))
          .add(1, "h")
          .valueOf();
        this.oddsQueryData.endTime = endTime;
        let beginTime = this.$moment(Number(orderTime))
          .subtract(1, "h")
          .valueOf();
        this.oddsQueryData.beginTime = beginTime;
        this.getOddsList();
        this.$refs["dialogDom"].isShowDia(this.title, true, "496px");
      }
    },
    async getOddsList() {
      this.dialogLoading = true;
      try {
        const res = await getOddsList(this.oddsQueryData);
        const data = res.data || [];
        this.oddsList = data;
        this.dialogLoading = false;
      } catch (error) {
        this.oddsList = [];
        this.dialogLoading = false;
      }
    },
    moreOddsList() {
      this.oddsQueryData.endTime = "";
      this.oddsQueryData.beginTime = "";
      this.getOddsList();
    },
    async getCashoutList() {
      this.dialogLoading = true;
      try {
        const res = await getCashoutList(this.cashoutQueryData);
        const data = res.data || [];
        this.cashoutList = data || [];
        this.dialogLoading = false;
      } catch (error) {
        this.cashoutList = [];
        this.dialogLoading = false;
      }
    },
    odds(maxWinAmount, stake, betNum) {
      return formatAmount(
        (Number(stake) + Number(maxWinAmount)) /
          (Number(stake) / Number(betNum))
      );
    },
    handleExport() {
      this.queryData.timeZoneOffset = new Date().getTimezoneOffset();
      getExport(this.queryData, "export.xlsx");
    },
    getAllSearch() {
      this.allSearchVisible = !this.allSearchVisible;
    },
    // merchant下拉框
    async getMerchatList() {
      const res = await getMerchat({});
      let data = res.data || {};
      this.merchatList = this.getArray(data);
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    }
  },
  mounted() {
    const { ip, stime, etime } = this.$route.query;
    if (stime || etime) {
      this.queryData.orderStartTime = stime;
      this.queryData.orderEndTime = etime;
      this.orderTime = [stime, etime];
      this.queryData.ip = ip;
    } else {
      let d = [];
      d = [
        new Date(new Date().toLocaleDateString()).getTime(),
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ];
      this.queryData.orderStartTime = d[0];
      this.queryData.orderEndTime = d[1];
      this.orderTime = [d[0], d[1]];
    }

    this.getList();
    this.getSportList();
    this.getMerchatList();
    this.getRiskflagList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.middle-btn {
  margin: 18px 15px;
}
.order-table,
.pagination-wrapper {
  margin: 18px 15px 0;
}
.match {
  font-size: 10px;
  color: #999;
  .matchId {
    color: #666;
  }
  .home-away {
    font-size: 12px;
    color: #333;
  }
}
.result {
  color: #999;
  .result-text {
    position: relative;
    font-weight: bold;
    span {
      display: inline-block;
      width: 7px;
      height: 7px;
      top: -3px;
      left: -4px;
      position: absolute;
      border-radius: 50%;
    }
  }
}
.region,
.ip {
  color: #999;
}
.dialog-odd-wrapper {
  position: relative;
}
.dialog-more {
  position: absolute;
  top: -41px;
  z-index: 999;
  margin: 0 0 12px 0;
}

.select-btn {
  margin: 0 10px 0 0;
}
</style>
